import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { TicketCreateForm } from "@/features/tickets/TicketCreateForm";
import type { TicketSource } from "@/features/tickets/types";

const searchSchema = z.object({
  source: z.enum(["QR", "Manual", "Asset Detail", "Cross Department"]).optional(),
  qr: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/assets/$assetId/report-issue")({
  validateSearch: (s) => searchSchema.parse(s),
  component: ReportIssuePage,
});

function ReportIssuePage() {
  const { assetId } = Route.useParams();
  const { source, qr } = Route.useSearch();
  const navigate = useNavigate();
  const sourceType: TicketSource = source ?? "Asset Detail";
  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <Button variant="ghost" size="sm" onClick={() => navigate({ to: "/assets/$assetId", params: { assetId } })}>
        <ArrowLeft className="mr-1 h-4 w-4" />Back to asset
      </Button>
      <h1 className="text-2xl font-semibold">Create Ticket</h1>
      <TicketCreateForm mode="preselected" assetId={assetId} source={sourceType} qrScanId={qr} />
    </div>
  );
}
